<template>
  <v-card v-if="(items && items.length > 0) || isSomeAdmin">
    <Subheader>
      <template v-slot:title>
        <v-toolbar-title>
          <v-icon medium>dashboard</v-icon>
          <span class="headline">Associated Content</span>
        </v-toolbar-title>
        <v-spacer />
      </template>
      <template v-slot:actions>
        <SecondaryBtn color="success" light icon="library_add" v-if="isAuthed && isSomeAdmin && isEdit" @click="onAdd" :disabled="isReorderingItems" small>
          Add
        </SecondaryBtn>
        <SecondaryBtn :color="actionButtonInfo.color" light :icon="actionButtonInfo.icon" v-if="isAuthed && isSomeAdmin" small @click="actionButtonInfo.onClick" :loading="isReorderingItems">
          {{ actionButtonInfo.text }}
        </SecondaryBtn>
      </template>
    </Subheader>

    <StaticContentItemList :isEdit="isEdit" :tenant-name="tenantName" />
    <StaticContentFormModal add-form :tenant-name="tenantName" ref="form" />
  </v-card>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const authenticate = createNamespacedHelpers('authenticate')
  const landingPageStaticContent = createNamespacedHelpers('landingPageStaticContent')
  const app = createNamespacedHelpers('app')

  import StaticContentItemList from '@/components/LandingPageStaticContent/StaticContentItemList'
  import StaticContentFormModal from '@/components/LandingPageStaticContent/Form/StaticContentFormModal'

  export default {
    components: {
      StaticContentItemList,
      StaticContentFormModal,
    },
    props: {
      tenantName: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        isEdit: false,
      }
    },
    computed: {
      ...authenticate.mapGetters(['isAuthed', 'isSomeAdmin', 'currentTenant']),
      ...landingPageStaticContent.mapState(['isReorderingItems', 'items']),
      actionButtonInfo() {
        return this.isEdit ? { text: 'Done', color: 'primary', icon: 'done', onClick: () => this.exitEdit() } : { text: 'Edit', color: 'warning', icon: 'edit', onClick: () => this.activateEdit() }
      },
      currentTenantName() {
        return this.currentTenant && this.currentTenant.name
      },
      noItems() {
        return this.items.data.length == 0
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...landingPageStaticContent.mapActions(['getStaticContentItems', 'getStaticContentTemplates']),
      activateEdit() {
        this.isEdit = true
      },
      exitEdit() {
        this.isEdit = false
      },
      onAdd() {
        this.$refs.form.show()
      },
    },
    async mounted() {
      let fetchParams = { forced: false }
      const isCrossTenant = this.tenantName != '' && this.tenantName != this.currentTenantName
      if (isCrossTenant) {
        fetchParams = Object.assign({}, fetchParams, { tenantName: this.tenantName, forced: true })
      }
      const fetchTemplatesPromise = this.getStaticContentTemplates(fetchParams)
      const fetchItemsPromise = this.getStaticContentItems(fetchParams)
      try {
        await Promise.all([fetchTemplatesPromise, fetchItemsPromise])
      } catch (ex) {
        this.setSnackbar({
          text: `Failed to fetch static content templates / items from the server, please refresh the page again. ${ex}`,
          icon: 'error',
          color: 'error',
        })
      }
    },
  }
</script>